var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"com-loading",style:(_vm.loadStyle)},[_c('div',{staticClass:"com-loading-icon-ing"},[_c('hxm-loading',[_vm._v("加载中")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }